export default {
    InlineImageLoad: {
        datapoint: {
            name: 'InlineImageLoad',
            customData: (
                type: string,
                howLoad: string,
                error: string,
                context: string,
                loaderCode: string,
                field1: string
            ) => [type, howLoad, error, context, loaderCode, field1],
        },
    },

    // The reporting framework currently only aggregates first 4 custom data. Custom data beyond 4 requires running ad hoc query
    // directly against cosmos. To make most use of it, I'm putting the first 4 custom data as: error, type, howLoad, statusCode
    InlineImageLoadError: {
        datapoint: {
            name: 'InlineImageLoadError',
            customData: (
                type: string,
                howLoad: string,
                error: string,
                statusCode: string,
                context: string,
                loaderCode: string,
                originalSrc: string,
                contentType: string,
                field1: string,
                field2: string,
                field3: string,
                field4: string,
                field5: string,
                field6: string
            ) => [
                type,
                howLoad,
                error,
                statusCode,
                context,
                loaderCode,
                originalSrc,
                contentType,
                field1,
                field2,
                field3,
                field4,
                field5,
                field6,
            ],
        },
    },

    ImageUploading: {
        datapoint: {
            name: 'InlineImageAttachmentUpload',
            customData: (fileType: string) => [fileType],
        },
    },

    CreateDataURIMissingNaturalDimensions: {
        datapoint: {
            name: 'CreateDataURIMissingNaturalDimensions',
        },
    },

    ImageCopyHandlerNullDataURI: {
        datapoint: {
            name: 'ImageCopyHandlerNullDataURI',
        },
    },
};
